import { useFeatureFlagEnabled } from '@posthog/react';
import { postHogService } from '@/lib/posthog';
import type { FeatureFlagKey } from '@/lib/feature-flag-constants';

export function useFeatureGate(featureFlag: FeatureFlagKey): boolean {
    const isEnabled = useFeatureFlagEnabled(featureFlag);

    if (!postHogService.isEnabled) {
        return true;
    }

    return isEnabled === true;
}
